import React, { Component, Fragment } from 'react';
import Select from 'react-select';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { withTranslation } from 'next-i18next';
import Router from 'next/router';
import Image from "next/legacy/image";
import 'swiper/css';
import "swiper/css/navigation";
import { DebounceInput } from "react-debounce-input";

// To include the default styles
import 'react-rangeslider/lib/index.css';

//DatePicker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// images
import avatar from '../../../public/img/calendar-NFT.png';
import verified from "../../../public/tick.png";

// icons
import {  CloseIcon, SearchIcon } from '../../icons'

// Styles
import styles from "./CommonFilterDesktop.module.scss";

class CommonFilterDesktop extends Component {
    state = {
        recentOption: null,
        categoryList: [],
        selectedCollection: [],
        //network
        networkList: [
            { id: 0, name: this.props.t('common:all'), class: "" },
            { id: 1, name: this.props.t('common:ethereum'), class: "" },
            { id: 2, name: this.props.t('common:polygon'), class: "" }
        ],

        //type
        type: 0,
        typeDropdown: [
            { value: 0, label: this.props.t('common:all') },
            { value: 1, label: this.props.t('common:single') },
            { value: 2, label: this.props.t('common:multiple') }
        ],

        //creator
        creator: false,
        creatorDropdown: [
            { value: false, label: this.props.t('common:all') },
            { value: true, label: this.props.t('common:verified') }
        ],

        //options
        options: 0,
        optionsDropdown: [
            { value: 2, label: this.props.t('common:minted_option') },
            { value: 1, label: this.props.t('common:lazy_minted_option') }
        ],

        //options
        owners: false,
        ownersDropdown: [
            { value: false, label: this.props.t('common:all') },
            { value: true, label: this.props.t('common:me') }
        ],

        //events type
        event: false,
        eventTypeDropdown: [
            { value: false, label: this.props.t('common:lazymint') },
            // { value: true, label: this.props.t('common:listings')},
            // { value: true, label: this.props.t('common:nft_offers')},
            // { value: true, label: this.props.t('common:collection_offers')},
            { value: true, label: this.props.t('common:transfers')}
        ],

        //character set
        character: false,
        characterDropdown: [
            { value: false, label: this.props.t('common:letter') },
            // { value: false, label: this.props.t('common:mixed')},
            { value: false, label: this.props.t('common:alphabets')},
            { value: false, label: this.props.t('common:digits')},
            { value: false, label: this.props.t('common:emoji')}
        ],
        

        sortListDropdown: [],
        sort: [
            { value: 1, label: this.props.t('common:price_low_high') }
        ],

        sliderValue: 0,
        cur_category: "0",
        cur_chain: 0,
        isOpen: this.props.isOpen,

        //Currency
        curCurrency: { value: 1, label: "USD" },
        currencyListMenu: [
            { value: 1, label: "USD" },
        ],

        //option
        option: 0,
        optionListDropdown: [
            { value: 0, label: this.props.t('common:all_nfts') },
            { value: 1, label: this.props.t('common:buy_now') },
            { value: 2, label: this.props.t('common:live_auction') }
            // { value: 1, label: this.props.t('common:') }
        ],

        // category for mobile
        cat: { value: 0, label: "❇️ " + this.props.t('common:all') },
        cList: [],

        //category for ens collection
        category: 2,
        categoryListMenu: [
            { value: 0, label: "Arabic 999 club" },
            { value: 1, label: "Arabic 10k club" },
            { value: 2, label: "Arabic 100k club" },
            { value: 3, label: "100k club" },
            { value: 4, label: "10k club" },

        ],
        selectedCategoryListMenu: { 0: false, 1: false, 2: false, 3: false, 4: false },

        // Price range
        min_value: "",
        max_value: "",
        priceLabel: "",

        isDrpOpen: true,
        minError: "",
        maxError: "",
        abDis: true,
        isEnsClubSelected: false,

        //expiry data
        end_date: "",
        start_date: "",
        start_date_err: "",
        end_date_err: "",
        mintingType: "",
        selectedCharacterType: "",
        searchText:""

    };

    componentDidMount = () => {
        var sortListDropdown = [];
        const { t } = this.props;
        if (Router.router && Router.router.asPath && Router.router.asPath === '/nft/sale') {
            this.setState({
                sort: { value: 2, label: t('common:nft_50_off') }
            })
            this.setState({
                sortListDropdown: [
                    { value: 1, label: t('common:nft_25_off') },
                    { value: 2, label: t('common:nft_50_off') },
                    { value: 3, label: t('common:nft_75_off') },
                ]
            })
        } else {
            this.setState({
                sortListDropdown: [
                    { value: 0, label: t('common:recently_listed') },
                    { value: 1, label: t('common:price_low_high') },
                    { value: -1, label: t('common:price_hign_low') },
                ]
            })
        }
        this.setState({ categoryList: this.props.categoryList, cList: this.props.cList });
        if (this.props.isFire === true) {
            this.setUrlValues();
        }
        if (Router.router && Router.router.asPath && Router.router.asPath === '/nft/explore') {
            this.setState({
                networkList: [
                    { id: 1, name: this.props.t('common:ethereum'), class: "" },
                    { id: 2, name: this.props.t('common:polygon'), class: "" }
                ],
                cur_chain: 1
            })
        }
        if (Router.router && Router.router.asPath && Router.router.asPath === '/nft/live-auction') {
            this.setState({
                optionListDropdown: [
                    { value: 0, label: this.props.t('common:all_nfts') },
                    { value: 1, label: this.props.t('common:lazy_mint') }
                ]
            })
        }
        if (this.props.chainIndex) {
            if (parseInt(this.props.chainIndex) === 1) {
                this.setState({
                    currencyListMenu: [
                        { value: 1, label: "USD" },
                        { value: 0, label: "ETH" },
                    ]
                })
            }
            if (parseInt(this.props.chainIndex) === 2) {
                this.setState({
                    currencyListMenu: [
                        { value: 1, label: "USD" },
                        { value: 0, label: "MATIC" },
                    ]
                })
            }
            if (parseInt(this.props.chainIndex) === 0) {
                this.setState({
                    currencyListMenu: [
                        { value: 1, label: "USD" }
                    ]
                })
            }
            if (this.props.is_cleared) {
                this.setState({ start_date: "", end_date: "" })
            }
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (this.props !== prevProps) {
            this.setState({ categoryList: this.props.categoryList, cList: this.props.cList });
            if (this.props.network !== prevProps.network) {
                this.setState({ priceLabel: "", min_value: "", max_value: "", curCurrency: { value: 0, label: "USD" } });
            }
            if (this.props.chainIndex !== prevProps.chainIndex) {
                if (parseInt(this.props.chainIndex) === 1) {
                    this.setState({
                        currencyListMenu: [
                            { value: 1, label: "USD" },
                            { value: 0, label: "ETH" },
                        ]
                    })
                }
                if (parseInt(this.props.chainIndex) === 2) {
                    this.setState({
                        currencyListMenu: [
                            { value: 1, label: "USD" },
                            { value: 0, label: "MATIC" },
                        ]
                    })
                }
                if (parseInt(this.props.chainIndex) === 0) {
                    this.setState({
                        currencyListMenu: [
                            { value: 1, label: "USD" }
                        ]
                    })
                }
            }
        }
    }

    setUrlValues = () => {

        // chain
        if (this.props.chain && this.props.chain !== "") {
            this.setState({ cur_chain: parseInt(this.props.chain) });
        }

        // type
        if (this.props.type && this.props.type !== "") {
            var item_result = this.state.typeDropdown.find(x => x.value === parseInt(this.props.type));
            this.setState({ type: item_result });
        }

        // creator
        if (this.props.creator && this.props.creator !== "") {
            var creator_result = this.state.creatorDropdown.find(x => x.value === Boolean(this.props.creator));
            this.setState({ creator: creator_result });
        }

        // currency 
        if (this.props.min_price && parseInt(this.props.min_price) !== 0 && this.props.min_price !== "" && this.props.max_price && parseInt(this.props.max_price) !== 0 && this.props.max_price !== "") {
            this.setState({ min_value: parseFloat(this.props.min_price), max_value: parseFloat(this.props.max_price) });
            let currencyListMenu = [{ value: 0, label: "USD" }, { value: 1, label: "ETH" }, { value: 2, label: "MATIC" }];
            var cur_result = currencyListMenu.find(x => x.value === parseInt(this.props.currency));
            this.setState({ curCurrency: cur_result });
        }
        this.props.applyAll(this.props.chain, this.props.type, this.props.creator, this.props.currency, this.props.min_price, this.props.max_price);

    }


    handleChangeBlockchain = (opt) => {
        this.setState({ cur_chain: opt }, () => {
            this.props.changeNetwork(opt);
            this.setCurrencyDropdownValues(opt);
            this.setState({ priceLabel: "", min_value: "", max_value: "", curCurrency: { value: 0, label: "USD" } });
            if (document.getElementById('drpdwn')) {
                document.getElementById('drpdwn').classList.add('d-none');
            }
        });
    };

    setCurrencyDropdownValues = (val) => {
        if (val === 0) {
            this.setState({ currencyListMenu: [{ value: 0, label: "USD" }] });
        }
        if (val === 1) {
            this.setState({ currencyListMenu: [{ value: 0, label: "USD" }, { value: 1, label: "ETH" }] });
        }
        else if (val === 2) {
            this.setState({ currencyListMenu: [{ value: 0, label: "USD" }, { value: 2, label: "MATIC" }] });
        }
    }

    handleChangeType = (opt) => {
        this.setState({ type: opt }, () => {
            this.props.changeType(opt);
        });
    };

    handleChangeCreator = (opt) => {
        this.setState({ creator: opt }, () => {
            this.props.changeCreator(opt);
        });
    };

    handleChangeCharacterSet = (opt) => {
        this.setState({ selectedCharacterType: opt }, () => {
            this.props.changeCharacterType(opt);
        });
    };

    handleEventTypeChange = (opt) => {
        this.setState({ event: opt }, () => {
            this.props.changeEventType(opt);
        });
    };

    handleChangeMintingType = (opt) => {

        if(this.state.options == opt){
            this.setState({ options: 0 }, () => {
                this.props.changeMintingType(0);
            });
        }else{
            this.setState({ options: opt }, () => {
                this.props.changeMintingType(opt);
            });
        }
    };

    handleChangeCollection = (opt) => {
        const collectionList = this.state.selectedCollection;
        // collectionList.push(opt)
        if(collectionList.includes(opt)){
            // collectionList.pop(opt)
            collectionList.splice(collectionList.indexOf(opt),1)
        }else{
            collectionList.push(opt)
        }
        this.props.changeSelectedCollection(opt);

        this.setState({ selectedCollection: collectionList });
    }

    changeOwnedOption = (opt) => {
        this.setState({ owners: opt }, () => {
            this.props.ownedStatus(opt);
        });
    }

    lowerChainIdx = (idx) => {
        this.setCurrencyDropdownValues(idx);
        this.props.changeChainIndex(idx);
        this.setState({ cur_chain: idx, priceLabel: "", min_value: "", max_value: "", curCurrency: { value: 0, label: "USD" } });
        if (document.getElementById('drpdwn')) {
            document.getElementById('drpdwn').classList.add('d-none');
        }
    }

    changeCategory = (info) => {
        this.setState({ cur_category: info }, () => { this.props.changeCategory(info); });
    }

    changeEnsCategoryClub = (val) => {
        this.setState({ selectedCategoryListMenu: this.props.category })
        this.setState((prevState) => ({
            selectedCategoryListMenu: { ...prevState.selectedCategoryListMenu, [val]: !prevState.selectedCategoryListMenu[val] },
            category: !this.state.isEnsClubSelected ? val : 4,
            isEnsClubSelected: !this.state.isEnsClubSelected
        }), () => {
            this.props.changeEnsCategory(this.state.isEnsClubSelected ? val : 4, this.state.selectedCategoryListMenu);
        });
    }

    handleChangeCategory = (info) => {
        this.setState({ cat: info }, () => { this.props.changeCategory(info.value); });
    }

    handleChangeCurrency = (item) => {
        this.setState({ curCurrency: item }, () => { this.setPriceLabel(); });
    }

    setPriceLabel = () => {
        if (this.state.min_value !== 0 && this.state.min_value !== "" && this.state.max_value !== 0 && this.state.max_value !== "") {
            let pl = this.state.curCurrency.label + "-" + parseFloat(this.state.min_value).toFixed(1) + "-" + parseFloat(this.state.max_value).toFixed(1);
            this.setState({ priceLabel: pl });
        }
    }

    setMinPrice = (e) => {

        if (this.props.clear_min_max) {
            this.props.clear_min_max()
        }

        let mp = e.target.value;

        if (Math.sign(mp) === -1) {
            this.setState({ priceError: this.props.t('common:must_positive'), abDis: true });
        }
        // else if(Math.sign(mp) === 0) {
        //     this.setState({ min_value: mp,priceError: "" , abDis: true });
        // }
        else if (parseFloat(mp) > parseFloat(this.state.max_value)) {
            this.setState({ min_value: mp, priceError: this.props.t('common:price_val'), abDis: true });
        }

        else {
            this.setState({ min_value: mp, priceError: "", abDis: false }, () => { this.setPriceLabel(); });
        }
    }

    setMaxPrice = (e) => {

        if (this.props.clear_min_max) {
            this.props.clear_min_max()
        }

        let mp = e.target.value;
        if (Math.sign(mp) === -1) {
            this.setState({ priceError: this.props.t('common:must_positive'), abDis: true });
        }

        else if (parseFloat(this.state.min_value) > parseFloat(mp)) {
            this.setState({ max_value: mp, priceError: this.props.t('common:price_val'), abDis: true });
        }

        else {
            this.setState({ max_value: mp, priceError: "", abDis: false }, () => { this.setPriceLabel(); });
        }
    }

    applyPrice = () => {
        this.props.applyPrice(this.state.min_value, this.state.max_value, this.state.curCurrency.value);
        // document.getElementById('drpdwn').classList.add('d-none');
        // this.setState({ min_value : "", max_value : "", priceLabel : "", curCurrency: { value: 0, label: "USD" }});
    }

    handleChangeOption = (opt) => {
        this.setState({ option: opt }, () => { this.props.changeOptions(opt); });
    }

    resetPrice = () => {
        this.setState({ priceLabel: "", min_value: "", max_value: "", curCurrency: { value: 0, label: "USD" } }, () => {
            this.props.applyPrice(0, 0, this.state.curCurrency.value);
        });
    }

    removeClassFromDropdown = () => {
        if (document.getElementById("drpdwn") && document.getElementById("drpdwn").classList.contains("d-none")) {
            document.getElementById('drpdwn').classList.remove('d-none')
        }
    }

    handleSorting = (sort) => {
        this.setState({ sort }, () => {
            this.props.changePriceSort(sort.value);
        });
    };

    updateStartDate = (date) => {
        if (this.props.is_cleared) {
            this.setState({ end_date: "", start_date: "" })
        }
        this.props.updateCleared()
        if (this.state.end_date && new Date(date) > new Date(this.state.end_date)) {
            this.setState({ start_date_err: t("start_dat_cond"), start_date: date })
        }

        else {
            this.setState({ start_date: date, start_date_err: "" })
        }
    }
    updateEndDate = (date) => {
        if (this.props.is_cleared) {
            this.setState({ end_date: "", start_date: "" })
        }
        this.props.updateCleared()
        if (this.state.start_date && new Date(date) < new Date(this.state.start_date)) {
            this.setState({ end_date_err: t("end_date_cond"), end_date: date })
        }
        else {
            this.setState({ end_date: date, end_date_err: "" })
        }
    }

    applyExpiryfilter = (e) => {
        e.preventDefault();

        const startDate = parseInt(new Date(this.state.start_date).getTime() / 1000)
        const endDate = parseInt(new Date(this.state.end_date).getTime() / 1000)

        this.props.applyExpiryDates(startDate, endDate)
    }

    hidefilter = (e) => {
        document.getElementById("cmnFltr").classList.remove("FilterOpen");
        document.getElementById("fBtn").classList.remove("Filterbtn_Active");
    }

    render() {
        const { t } = this.props;
        const router = Router.router

        return (
            <Accordion.Collapse eventKey={0}>
                <Card.Body className="p-0">
                    <div className={`d-block d-md-none ${styles.commonFClose}`}>
                        <div className={`d-flex justify-content-between ${styles.title}`}>
                            <div className='h2'>{t('common:filters')}</div>
                            <div className={styles.FClose} onClick={this.hidefilter}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" fill="none" viewBox="0 0 14 15"><path fillRule="evenodd" d="M.293 1.289a1 1 0 0 1 1.414 0L7 6.582l5.293-5.293a1 1 0 0 1 1.414 1.414L8.414 7.996l5.293 5.293a1 1 0 0 1-1.414 1.414L7 9.41l-5.293 5.293a1 1 0 0 1-1.414 0 1 1 0 0 1 0-1.414l5.293-5.293L.293 2.703a1 1 0 0 1 0-1.414z" fill="#23262f"></path></svg>
                            </div>
                        </div>
                    </div>
                    <Accordion className={styles.cmnFilter} alwaysOpen>
                        {router && router.pathname !== '/nft/collections/[collectionId]' && router.pathname !== '/nft/explore/[exploreName]' ?
                            <Accordion.Item eventKey="0">
                                <Accordion.Header as="div">{t('common:blockchain')}</Accordion.Header>
                                <Accordion.Body>
                                    <div className={styles.filterUl}>
                                        <ul>
                                            {this.state.networkList.map((item, idx) => {
                                                return (
                                                    <li key={idx} className={this.props.network === item.id ? "active" : ""} onClick={() => this.handleChangeBlockchain(item.id)}>
                                                        {item.name}
                                                        <span className={styles.checkmark}>
                                                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> :
                            null}

                        {router && (router.pathname === '/nft/collections/[collectionId]' || router.pathname === '/nft/live-auction') ?
                            <Accordion.Item eventKey="1">
                                <Accordion.Header as="div">{t('common:status')}</Accordion.Header>
                                <Accordion.Body>
                                    <div className={styles.filterUl}>
                                        <ul>
                                            {this.state.optionListDropdown.map((status, ids) => {
                                                return (
                                                    <li key={ids} className={this.props.status === status.value ? "active" : ""} onClick={() => this.handleChangeOption(status.value)}>
                                                        {status.label}
                                                        <span className={styles.checkmark}>
                                                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> :
                            null}

                        {router && router.pathname !== '/nft/collections/[collectionId]' && router.pathname !== '/nft/live-auction' ?
                            <Accordion.Item eventKey="2">
                                <Accordion.Header as="div">{t('common:type')}</Accordion.Header>
                                <Accordion.Body>
                                    <div className={styles.filterUl}>
                                        <ul>
                                            {this.state.typeDropdown.map((type, idt) => {
                                                return (
                                                    <li key={idt} className={this.props.type === type.value ? "active" : ""} onClick={() => this.handleChangeType(type.value)}>
                                                        {type.label}
                                                        <span className={styles.checkmark}>
                                                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> :
                            null}

                        {router && (router.pathname !== '/nft/collections/[collectionId]' && router.pathname !== '/nft/profiles/[profileName]') ?
                            <Accordion.Item eventKey="3">
                                <Accordion.Header as="div">{t('common:creator')}</Accordion.Header>
                                <Accordion.Body>
                                    <div className={styles.filterUl}>
                                        <ul>
                                            {this.state.creatorDropdown.map((creator) => {
                                                return (
                                                    <li key={creator.label} className={this.props.creator === creator.value ? "active" : ""} onClick={() => this.handleChangeCreator(creator.value)}>
                                                        {creator.label}
                                                        <span className={styles.checkmark}>
                                                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> :
                            null}

                        {/* {router && router.pathname !== '/nft/profiles/[profileName]' ?
                        <Accordion.Item eventKey="7">
                            <Accordion.Header as="div">{t('common:collections')}</Accordion.Header>
                            <Accordion.Body>
                                <div className={styles.filterUl}>
                                    <ul>
                                        <li>
                                            <div className={`d-flex ${styles.list_coll}`}>
                                                <div className={`d-flex ${styles.list_title}`}>
                                                    <Image src={avatar} alt="Avatar" width={20} height={20} layout='responsive' />
                                                    <div className={`d-flex ${styles.card__title}`}>
                                                       <p>Haitham Gamal</p>
                                                        <TickMark />
                                                    </div>
                                                </div>
                                                <div className={styles.list_total}>
                                                    39,215
                                                </div>
                                            </div>
                                            <span className={styles.checkmark}>
                                                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                </svg>
                                            </span>
                                        </li>
                                        <li>
                                            <div className={`d-flex ${styles.list_coll}`}>
                                                <div className={`d-flex ${styles.list_title}`}>
                                                    <Image src={avatar} alt="Avatar" width={20} height={20} layout='responsive' />
                                                    <div className={`d-flex ${styles.card__title}`}>
                                                       <p>Haitham Gamal</p>
                                                        <TickMark />
                                                    </div>
                                                </div>
                                                <div className={styles.list_total}>
                                                    39,215
                                                </div>
                                            </div>
                                            <span className={styles.checkmark}>
                                                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                </svg>
                                            </span>
                                        </li>
                                        <li>
                                            <div className={`d-flex ${styles.list_coll}`}>
                                                <div className={`d-flex ${styles.list_title}`}>
                                                    <Image src={avatar} alt="Avatar" width={20} height={20} layout='responsive' />
                                                    <div className={`d-flex ${styles.card__title}`}>
                                                       <p>Haitham Gamal</p>
                                                        <TickMark />
                                                    </div>
                                                </div>
                                                <div className={styles.list_total}>
                                                    39,215
                                                </div>
                                            </div>
                                            <span className={styles.checkmark}>
                                                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                </svg>
                                            </span>
                                        </li>
                                        <li>
                                            <div className={`d-flex ${styles.list_coll}`}>
                                                <div className={`d-flex ${styles.list_title}`}>
                                                    <Image src={avatar} alt="Avatar" width={20} height={20} layout='responsive' />
                                                    <div className={`d-flex ${styles.card__title}`}>
                                                       <p>Haitham Gamal</p>
                                                        <TickMark />
                                                    </div>
                                                </div>
                                                <div className={styles.list_total}>
                                                    39,215
                                                </div>
                                            </div>
                                            <span className={styles.checkmark}>
                                                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                </svg>
                                            </span>
                                        </li>
                                        <li>
                                            <div className={`d-flex ${styles.list_coll}`}>
                                                <div className={`d-flex ${styles.list_title}`}>
                                                    <Image src={avatar} alt="Avatar" width={20} height={20} layout='responsive' />
                                                    <div className={`d-flex ${styles.card__title}`}>
                                                       <p>Haitham Gamal</p>
                                                        <TickMark />
                                                    </div>
                                                </div>
                                                <div className={styles.list_total}>
                                                    39,215
                                                </div>
                                            </div>
                                            <span className={styles.checkmark}>
                                                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                </svg>
                                            </span>
                                        </li>
                                        <li>
                                            <div className={`d-flex ${styles.list_coll}`}>
                                                <div className={`d-flex ${styles.list_title}`}>
                                                    <Image src={avatar} alt="Avatar" width={20} height={20} layout='responsive' />
                                                    <div className={`d-flex ${styles.card__title}`}>
                                                       <p>Haitham Gamal</p>
                                                        <TickMark />
                                                    </div>
                                                </div>
                                                <div className={styles.list_total}>
                                                    39,215
                                                </div>
                                            </div>
                                            <span className={styles.checkmark}>
                                                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                </svg>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        :
                        null
                        } */}

                        {router && router.pathname !== '/nft/live-auction' && router.pathname !== '/nft/profiles/[profileName]' ?
                            <Accordion.Item eventKey="4">
                                <Accordion.Header as="div">{t('common:price')}</Accordion.Header>
                                <Accordion.Body>
                                    <div className="rangeSlider">
                                        <div className={`form-group ${styles.inputGroup}`}>
                                            <div className="selectMenu">
                                                <Select
                                                    value={this.state.curCurrency}
                                                    onChange={this.handleChangeCurrency}
                                                    options={this.state.currencyListMenu}
                                                    classNamePrefix="select__Inner"
                                                    placeholder={t('common:price_range_placeholder')}
                                                    isSearchable={false}
                                                    instanceId="creator"
                                                />
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <InputGroup>
                                                    <Form.Control onChange={this.setMinPrice} type="number" placeholder={t('common:min')} value={this.props.min_clear ? "" : this.state.min_value} />
                                                </InputGroup>
                                                <span>{t('common:price_to')}</span>
                                                <InputGroup>
                                                    <Form.Control onChange={this.setMaxPrice} type="number" placeholder={t('common:max')} value={this.props.max_clear ? "" : this.state.max_value} />
                                                </InputGroup>
                                            </div>
                                        </div>
                                        {this.state.priceError && <div className='valmsg mb-2'>{this.state.priceError}</div>}
                                        <div className={`d-flex ${styles.btns}`}>
                                            {/* <button className='btn buttonStroke flex-grow-1 w-100' onClick={this.resetPrice}>{t('common:clear')}</button> */}
                                            <button disabled={(this.state.priceError || (!this.state.min_value && !this.state.max_value) || this.props.min_clear || this.props.max_clear)} className='btn flex-grow-1 w-100' onClick={this.applyPrice}>{t('common:apply')}</button>
                                        </div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> :
                            null}

                        {router && (router.pathname !== '/nft/collections/[collectionId]' && router.pathname !== '/nft/live-auction') && router?.state?.query?.categoryName !== "domain-names"  ?
                            <Accordion.Item eventKey="21">
                                <Accordion.Header as="div">{t('common:options')}</Accordion.Header>
                                <Accordion.Body>
                                    <div className={styles.filterUl}>
                                        <ul>
                                            {this.state.optionsDropdown.map((options, idc) => {
                                                return (
                                                    <li key={options.label} className={this.props.options === options.value ? "active" : ""} onClick={() => { this.handleChangeMintingType(options.value)}}>
                                                        {options.label}
                                                        <span className={styles.checkmark}>
                                                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> : null
                        }
                        {router && (router.pathname === '/nft/explore' || '/nft/category') && this.props.collectionFilterNeeded ?
                            <Accordion.Item eventKey="22">
                                <Accordion.Header as="div">{t('common:collections')}</Accordion.Header>
                                <Accordion.Body>
                                    <div className={`position-relative ${styles.collListSearch}`}>
                                        <div className={`${styles.icons} ${styles.search}`}>
                                            <SearchIcon className={styles.searchicon} />
                                        </div>
                                        <button onClick={()=>{this.setState({searchText:""});this.setState({selectedCollection:[]});this.props.clearSearch()}} type="button" className={`${styles.icons} ${styles.close}`}>
                                            <CloseIcon />
                                        </button>
                                        <DebounceInput
                                            debounceTimeout={300}
                                            className={`form-control ${styles.header__input}`}
                                            type="text"
                                            value={this.state.searchText}
                                            placeholder="Search by Collections"
                                            onChange= {(e)=>{this.setState({searchText:e.target.value});this.props.searchCollection(e.target.value)}} />
                                    </div>
                                     <div className={styles.collList_filter}>
                                        <ul>
                                            {this.props?.collectionList?.length && this.props.collectionList.map((res,key)=>
                                            <li key={res?.collection_name} onClick={() => this.handleChangeCollection(res?.collection_id)} className={this.props.selectedCollectionP.includes(res?.collection_id) ? "active" : ""}>
                                                {/* <Link href="/nft/collections"> */}
                                                    <a className={`d-flex flex-grow-1 ${styles.list_wrap}`}>
                                                        <div className={`position-relative ${styles.card__avatar}`}>
                                                            <Image src={res?.image_url || avatar} alt={t('common:all_collections')} width={40} height={40} layout="responsive" />
                                                        </div>
                                                        <div className={styles.card_body}>
                                                            <div className={`d-flex ${styles.name}`}>
                                                                {res?.collection_name}
                                                                <div className={styles.done}>
                                                                    <Image src={verified} alt={t('common:all_collections')} width="16" height="16" layout='responsive' loading='lazy' />
                                                                </div>
                                                            </div>
                                                            {res?.floorPrice != "0" ? <div className={`d-flex align-items-center ${styles.content}`}>
                                                                <span className={styles.price_lbl}>{t('common:floor_price')}: </span>
                                                                {`${res?.floorPrice} ETH`} 
                                                            </div>:<Fragment />}
                                                        </div>
                                                        <span className={styles.checkmark}>
                                                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </a>
                                                {/* </Link> */}
                                            </li>)}
                                        </ul>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> : null
                        }

                        {router && (router.pathname === '/nft/collections/[collectionId]') && localStorage.getItem("user_id") ?
                            <Accordion.Item eventKey="23">
                                <Accordion.Header as="div">{t('common:owners')}</Accordion.Header>
                                <Accordion.Body>
                                    <div className={styles.filterUl}>
                                        <ul>
                                            {this.state.ownersDropdown.map((owners, idc) => {
                                                return (
                                                    <li key={owners.label} className={this.props.ownedByMe === owners.value ? "active" : ""} onClick={() => this.changeOwnedOption(owners.value)}>
                                                        {owners.label}
                                                        <span className={styles.checkmark}>
                                                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> : null
                        }

                    {router && (router.pathname === '/nft/profiles/[profileName]') && this.props.passEvent ?
                            <Accordion.Item eventKey="24">
                                <Accordion.Header as="div">{t('common:event_type')}</Accordion.Header>
                                <Accordion.Body>
                                    <div className={styles.filterUl}>
                                        <ul>
                                            {this.state.eventTypeDropdown.map((event, idc) => {
                                                return (
                                                    <li key={event.label} className={this.props.event === event.value ? "active" : ""} onClick={() => this.handleEventTypeChange(event.value)}>
                                                        {event.label}
                                                        <span className={styles.checkmark}>
                                                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> : null
                        }

                        {router && ((router.pathname === '/nft/collections/[collectionId]') && (router?.query?.collectionId === 'ens')) || (router?.query?.categoryName === 'domain-names') ?
                            <Accordion.Item eventKey="25">
                                <Accordion.Header as="div">{t('common:character_set')}</Accordion.Header>
                                <Accordion.Body>
                                    <div className={styles.filterUl}>
                                        <ul>
                                            {this.state.characterDropdown.map((character, idc) => {
                                                return (
                                                    <li key={character.label} className={this.props.characterSet === character.label ? "active" : ""} onClick={() => this.handleChangeCharacterSet(character.label)}>
                                                        {character.label}
                                                        <span className={styles.checkmark}>
                                                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> : null
                        }

                        {this.props.isCategoryShow ?
                            <Accordion.Item eventKey="5">
                                <Accordion.Header as="div">{t('common:category')}</Accordion.Header>
                                <Accordion.Body>
                                    <div className={styles.filterUl}>
                                        <ul>
                                            {this.state.categoryListMenu.map((category, idc) => {
                                                return (
                                                    <li key={category.label} className={this.props.category[category.value] ? "active" : ""}
                                                        onClick={() => this.changeEnsCategoryClub(category.value)}>
                                                        {category.label}
                                                        <span className={styles.checkmark}>
                                                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M11.7489 0.234315C12.0837 0.546734 12.0837 1.05327 11.7489 1.36569L4.89181 7.76569C4.55707 8.07811 4.01436 8.07811 3.67962 7.76569L0.251051 4.56569C-0.0836838 4.25327 -0.0836838 3.74673 0.251051 3.43431C0.585786 3.1219 1.1285 3.1219 1.46323 3.43431L4.28571 6.06863L10.5368 0.234315C10.8715 -0.0781049 11.4142 -0.0781049 11.7489 0.234315Z" fill="white" />
                                                            </svg>
                                                        </span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> :
                            null}
                        {
                            this.props.isCategoryShow ?
                            <>
                            
                                <Accordion.Item eventKey="6">
                                    <Accordion.Header as="div">{t('common:expiration_date')}</Accordion.Header>
                                    <Accordion.Body>
                                        <div className={`form-group ${styles.inputGroup}`}>
                                            <div className={`d-flex align-items-center ${styles.expire_Filter}`}>
                                                <DatePicker
                                                    selected={this.props.is_cleared ? "" : this.state.start_date}
                                                    className="form-control"
                                                    placeholderText={t('common:select')}
                                                    // minDate={new Date()}
                                                    popperPlacement="top"
                                                    // showTimeSelect
                                                    // filterTime={filterPassedTime}
                                                    showDisabledMonthNavigation
                                                    onChange={this.updateStartDate} />
                                                <span className={styles.to}>{t('common:to')}</span>
                                                <DatePicker
                                                    selected={this.props.is_cleared ? "" : this.state.end_date}
                                                    className="form-control"
                                                    placeholderText={t('common:select')}
                                                    // minDate={new Date()}
                                                    popperPlacement="top"
                                                    // showTimeSelect
                                                    // filterTime={filterPassedTime}
                                                    // dateFormat="dd/mm/yyyy"
                                                    showDisabledMonthNavigation
                                                    onChange={this.updateEndDate} />
                                            </div>
                                        </div>
                                        {this.state.start_date_err && <div className='valmsg'>{this.state.start_date_err}</div>}
                                        {this.state.end_date_err && <div className='valmsg'>{this.state.end_date_err}</div>}
                                        <div className={`d-flex ${styles.btns}`}>
                                            <button disabled={(this.state.start_date_err || this.state.end_date_err || !this.state.end_date || !this.state.start_date || this.props.is_cleared)} className='btn flex-grow-1 w-100' onClick={this.applyExpiryfilter}>{t('common:apply')}</button>
                                            {/* <button className='btn buttonStroke flex-grow-1 w-100' onClick={this.resetPrice}>{t('common:clear')}</button> */}

                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                
                                </>
                                :
                                null
                        }

                    </Accordion>
                    <div className={`d-block d-md-none ${styles.mobBtn}`}>
                        <div className={`d-flex ${styles.margn}`}>
                            <button className={`btn buttonStroke ${styles.clrall}`} onClick={(e) => this.props.clearAllFilters(e)}>{t('common:reset_all')}</button>
                            <button className={`btn ${styles.btnClassName}`} onClick={this.hidefilter}>{t('common:apply')}</button>
                        </div>
                    </div>
                </Card.Body>
            </Accordion.Collapse>
            //     {/* </Card>
            // </Accordion> */}
        )
    }
}
export default withTranslation()(CommonFilterDesktop);
